const ADMIN_EMAIL_DOMAINS: readonly string[] = ['trinityairmedical.com', 'srta.com', 'stratacritical.com'];

const ADMIN_EMAIL_REG_EX: readonly RegExp[] = ADMIN_EMAIL_DOMAINS.map(
  (domain) => new RegExp(`^[A-Za-z0-9._%+-]+@${domain.replace(/\./g, '\\.')}$`),
);

/**
 * whether the email belongs to a domain allowed to hold the Executive Admin role
 * @param email - email to check
 */
export const isAdminDomainEmail = (email: string): boolean => ADMIN_EMAIL_REG_EX.some((regEx) => regEx.test(email));
